<script>
import Layout from '../layouts/main';
import PageHeader from '@/components/page-header';
import axios from 'axios';
import { authFackMethods } from '@/state/helpers';

export default {
	page: {
		title: 'Registration Progress',
		meta: [
			{
				name: 'Registration Progress',
			},
		],
	},
	components: { Layout, PageHeader },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			userTypes: [
				{ value: 'mentor', text: 'Mentor' },
				{ value: 'volunteer', text: 'Volunteer' },
				{ value: 'mentor_volunteer', text: 'Mentor/Volunteer' },
			],
			preservePage: 1,
			pageLimit: 50,
			registeredUsers: {},
			searchForm: {
				username: null,
				psv_check: null,
				user_type_slug: null,
			},
			isName: false,
			isPsvCheck: false,
			isUserType: false,
			isSearching: false,
			isLoading: false,
			noRecord: false,
			searchBy: '',
			currentUserData: JSON.parse(localStorage.getItem('user')),
		};
	},
	mounted() {
		this.getRegisteredUsers();
	},
	methods: {
		getRegisteredUsers(page) {
			this.noRecord = false;
			this.isLoading = true;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.preservePage = page;
			let filter = '&per_page=' + this.pageLimit;
			if (this.searchForm.username) {
				filter += '&username=' + this.searchForm.username;
			}
			if (this.searchForm.psv_check) {
				filter += '&psv_check=' + encodeURIComponent(this.searchForm.psv_check);
			}
			if (this.searchForm.user_type_slug) {
				filter += '&user_type_slug=' + this.searchForm.user_type_slug;
			}
			//if not admin
			if (this.currentUserData.user_type_id !== 1 && this.currentUserData.user_type_id !== 5) {
				filter += '&location=yes';
				filter += '&user_id=' + this.currentUserData.id;
			}
			filter += '&front_application_status=complete';

			axios
				.get('admin/users/all/registered?pagination=true&page=' + page + filter)
				.then((res) => {
					this.registeredUsers = res.data.response;
					this.isLoading = false;
					if (!this.registeredUsers.data.length) {
						this.noRecord = true;
						if (page > 1) {
							this.getRegisteredUsers(page - 1);
						}
					}
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},
		...authFackMethods,

		searchOption(event) {
			this.searchForm = {
				username: null,
				psv_check: null,
				user_type_slug: null,
			};
			let selectedValue = event.target.value;
			if (selectedValue == '') {
				this.resetSearch();
			}
			if (selectedValue == 'name') {
				this.getRegisteredUsers();
				this.isName = true;
				this.isPsvCheck = false;
				this.isUserType = false;
				this.isSearching = true;
			}
			if (selectedValue == 'psv_check') {
				this.isName = false;
				this.isPsvCheck = true;
				this.isUserType = false;
				this.isSearching = true;
			}
			if (selectedValue == 'user_type') {
				this.isName = false;
				this.isPsvCheck = false;
				this.isUserType = true;
				this.isSearching = true;
			}
		},

		searchRegisteredUsers() {
			this.getRegisteredUsers();
		},

		resetSearch() {
			this.searchForm = {
				username: null,
				psv_check: null,
				user_type_slug: null,
			};
			this.isSearching = false;
			this.isName = false;
			this.isPsvCheck = false;
			this.isUserType = false;
			this.searchBy = '';
			this.getRegisteredUsers();
		},

		getFullName(user) {
			let fullname = '';
			if (user.first_name && user.first_name.length) {
				fullname += user.first_name;
			}
			if (user.last_name && user.last_name.length) {
				fullname += ' ' + user.last_name;
			}
			return fullname;
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />

		<!--Registration Progress-->
		<div class="card">
			<div class="card-body">
				<div class="d-flex">
					<div class="me-2">
						<h5 class="card-title mb-3">Application Progress</h5>
					</div>
				</div>

				<form class="row align-items-center form-inline mb-4 border p-3 m-0" @submit.prevent="searchRegisteredUsers">
					<div class="col-md-12">
						<h4 class="font-size-14">Search By:</h4>
					</div>
					<div class="col-md-4">
						<select class="form-select custom-select" v-model="searchBy" @change="searchOption($event)">
							<option value="">Select Option</option>
							<option value="name">Name</option>
							<option value="psv_check">Status</option>
							<option value="user_type">User Type</option>
						</select>
					</div>
					<div class="col-md-2 sm-hidden xs-hidden"></div>
					<div class="col-md-6 pull-right">
						<div class="row app-search pt-0 pb-0">
							<div class="col-md-12 d-flex">
								<input v-if="isName" v-model="searchForm.username" type="text" class="ps-4 form-control" placeholder="Type User Name" />
								<input v-if="isPsvCheck" v-model="searchForm.psv_check" type="text" class="ps-4 form-control" placeholder="Type Status" />
								<b-form-select v-if="isUserType" class="form-select" v-model="searchForm.user_type_slug" :options="userTypes">
									<option slot="first" :value="null" disabled>Select User Type</option>
								</b-form-select>
								<button v-if="isSearching" type="submit" class="btn btn-block btn-primary btn-find" id="show-btn"><i class="bx bx-search-alt-2"></i> Search</button>
								<button v-if="isSearching" type="button" class="btn btn-primary btn-reset ms-2" id="show-btn"><i class="bx bx-reset"></i> Reset</button>
							</div>
						</div>
					</div>
				</form>

				<div class="table-responsive">
					<table class="table table-bordered table-hover table-striped align-middle table-nowrap mb-0">
						<thead class="table-light">
							<tr>
								<th scope="col">Name</th>
								<th scope="col">Status</th>
								<th scope="col">Type</th>
								<th scope="col">Submission Date</th>
							</tr>
						</thead>
						<tbody>
							<tr v-if="noRecord">
								<td colspan="4" class="p-0">
									<p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
								</td>
							</tr>
							<tr v-if="isLoading">
								<td colspan="4" class="text-center p-0">
									<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
								</td>
							</tr>
							<tr v-else v-for="(registeredUser, registeredUserIndex) in registeredUsers.data" :key="registeredUserIndex">
								<td>
									<h5 class="font-size-13 text-truncate mb-1">
										<router-link tag="a" :to="`/registration-progress/user/${registeredUser.id}`" target="_blank">
											<span> {{ registeredUser.first_name != null ? getFullName(registeredUser) : registeredUser.username ? registeredUser.username : 'N/A' }} </span>
											<span v-if="registeredUser.first_name == null" class="badge border border-light rounded-circle bg-warning p-1">
												<span class="visually-hidden">Incomplete profile</span>
											</span>
										</router-link>
									</h5>
								</td>
								<td>
									<h5 class="font-size-13 text-truncate mb-1">
										<span v-if="registeredUser.psv_check == 'applicant'">Review Application</span>
										<span v-else>{{ registeredUser.user_current_status }}</span>
									</h5>
								</td>
								<td>
									<p class="text-muted mb-0">{{ registeredUser.UserType }}</p>
								</td>
								<td>
									<p class="text-muted mb-0">{{ registeredUser.date }}</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<pagination class="mt-4" :data="registeredUsers" :limit="10" @pagination-change-page="getRegisteredUsers"></pagination>
			</div>
		</div>
	</Layout>
</template>

<style scoped>
.app-search input,
.app-search select {
	border-top-right-radius: 0px;
	border-bottom-right-radius: 0px;
}
.app-search .btn-find {
	width: 40%;
	border-top-right-radius: 30px;
	border-bottom-right-radius: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 15px;
	box-shadow: none;
}
.app-search .btn-reset {
	width: 40%;
	font-size: 15px;
	box-shadow: none;
	border-radius: 30px;
}
</style>
